import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { isPlatformBrowser, formatDate } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { LeadFormComponent } from '../../shared/lead-form/lead-form.component';
import { APIService } from 'src/app/services/api.service';
import { link } from 'fs';
import {
  animate,
  query,
  stagger,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-new-home',
  templateUrl: './new-home.component.html',
  styleUrls: ['./new-home.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0, transform: 'translateY(20px)' })),
      transition(':enter, :increment', [
        animate(
          '0.5s ease-in-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '0.5s ease-in-out',
          style({ opacity: 0, transform: 'translateY(20px)' })
        ),
      ]),
    ]),
    trigger('staggerAnimation', [
      transition(':enter', [
        query('h1', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger('100ms', [
            animate(
              '0.5s ease-in-out',
              style({ opacity: 1, transform: 'translateY(0)' })
            ),
          ]),
        ]),
        query('p', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger('100ms', [
            animate(
              '0.5s ease-in-out',
              style({ opacity: 1, transform: 'translateY(0)' })
            ),
          ]),
        ]),
        query('.buttons', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger('100ms', [
            animate(
              '0.5s ease-in-out',
              style({ opacity: 1, transform: 'translateY(0)' })
            ),
          ]),
        ]),
        query(
          '.right-section',
          [
            style({ opacity: 0, transform: 'translateY(20px)' }),
            stagger('100ms', [
              animate(
                '0.5s ease-in-out',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
  standalone: false,
})
export class NewHomeComponent implements OnInit, OnDestroy {
  @ViewChild('inputWrapper') inputWrapper!: ElementRef;
  isInView = false;
  slideInt: any;
  selectedIndex = 0;
  slideInterval = 100;
  infiniteSlide = true;
  imageSize = {
    width: '80px',
    height: '80px',
    // space: 12,
  };

  imageSizeMobile = {
    width: '58px',
    height: '58px',
    // space: 6,
  };

  currentValue: number = 0;

  autoSlide = { interval: 1, stopOnHover: true };
  isImageLoaded: boolean = false;

  lottieOptions: AnimationOptions = {
    path: 'https://inforida.ams3.cdn.digitaloceanspaces.com/lottie/school-animation.json',
  };

  lottiePostJob: AnimationOptions = {
    path: 'https://inforida.ams3.cdn.digitaloceanspaces.com/lottie/post-job.json',
  };

  lottieFindJob: AnimationOptions = {
    path: 'https://inforida.ams3.cdn.digitaloceanspaces.com/lottie/find-job.json',
  };

  lottieTree: AnimationOptions = {
    path: '../../../assets/lottie/treeLottie.json',
  };

  description = [
    'Effortlessly <b> Create</b> A <b>Government-compliant public page</b> improving your digital presence ',
    'Showcase your school’s <b>Facilities</b>, <b>Infrastructure</b>, <b>achievements</b>. Easily Display events & Announcements with customisable banners ',
    'Edit the public page in <b>Real-Time</b> with millions of <b>Colours & Themes</b>',
  ];

  quickEnrollPoints = [
    {
      icon: '🔵',
      description:
        'Showcase your school’s <b>facilities, infrastructure, achievements</b>. Easily Display <b>Events</b> & <b>Announcements</b> with customisable banners ',
      buttonText: 'Learn how →',
      buttonColor: 'blue',
      shape: 'square',
    },
    {
      icon: '🔺',
      description:
        'Edit the public page in <b>Real-time</b> with millions of <b>Colours & themes</b>',
      buttonText: 'Learn how →',
      buttonColor: 'green',
      shape: 'triangle',
    },
    {
      icon: '🟡',
      description:
        'Effortlessly <b>Create</b> a <b>Government-compliant public page</b> improving your digital presence ',
      buttonText: 'Learn how →',
      buttonColor: 'yellow',
      shape: 'circle',
    },
  ];

  attendancePoints = [
    {
      icon: '🔵',
      description: 'Say Goodbye to Attendance Registers & Save Paper',
      buttonText: 'Learn how →',
      buttonColor: 'blue',
      textColor: 'white',
      shape: 'square',
    },
    {
      icon: '🔺',
      description: 'Save time on attendance & Spend Where It Matters',
      buttonText: 'Learn how →',
      buttonColor: 'green',
      textColor: 'white',
      shape: 'triangle',
    },
    {
      icon: '🟡',
      description: 'Protect Your Data with Secure Biometric Technology',
      buttonText: 'Learn how →',
      buttonColor: 'yellow',
      textColor: 'black',
      shape: 'circle',
    },
  ];

  goodmorningDescription = [
    'Say goodbye to <b> Attendance Registers</b> & <b>Save Paper</b>',
    '<b>Save Time</b> On Attendance & spend where it Matters',
    'Protect your data with <b>Secure Biometric</b> Technology',
  ];

  userCards: any = [
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-male-icon.png',
      name: 'Mr. Jai Singh, Principal',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `I was initially hesitant to take the software due to no technical knowledge, but within few days of using it, Inforida team has made me comfortable with the software and now I am so much dependent on it while managing my institution.`,
    },
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-female-icon.png',
      name: 'Mrs. Shivani Awasthi, Principal',
      school: 'Sanik Sanjeevani Public School, Sitapur',
      description: `The most economical and user friendly School Management System, Our School Staff is using it from past three years and found it surprisingly easy to use. The interface for School Admin, Accountant, Teachers, parents and student is attractive and very easy to follow.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/sakal.png',
      name: 'Mr. Sanjay Singh, Owner',
      school: 'Sakalnarayan Memorial Public School, Raebareli',
      description: `Our school was loosing ₹10-15 Lacks every acedemic session.
      Thanks to Inforida now I can manage, view and download all financial reports in one click from anywhere. We are using Inforida from last 4 years and never had any problems.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/mkd.png',
      name: 'Mr. Priyansh Dixit, Owner',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `The customer support team is super fast and attempts to solve every query/issue. Very easy to use, great school management system with an innovative approach for every problem faced in school administration.
      `,
    },
  ];

  boxes = [
    {
      image: '../../assets/images/mobile-dashboard.png',
      title: 'Mobile App',
      description: 'Stay connected and handle tasks on the go.',
      link: '#',
      linkText: 'Get Mobile App →',
    },
    {
      image: '../../assets/images/web-dashboard.png',
      title: 'Web Dashboard',
      description: 'Manage your school seamlessly from any computer, anytime.',
      link: '#',
      linkText: 'Get Dashboard App →',
    },
    {
      image: '../../assets/images/tablet-dashboard.png',
      title: 'Tablet Module',
      description: 'Effortless school management, right at your fingertips.',
      link: '#',
      linkText: 'Get Tablet App →',
    },
  ];

  benifits = [
    {
      icon: 'school',
      backgroundColor: 'rgba(221, 246, 230, 1)',
      title: 'Designed & Built for Schools in Mind',
      description:
        "Perfectly suited for your school's administration & operational needs.",
    },
    {
      icon: 'language',
      backgroundColor: 'rgba(216, 231, 255, 1)',
      title: 'Multi language support',
      description:
        'Engage seamlessly in the language that works best for you and your team.',
    },
    {
      icon: 'attach_money',
      backgroundColor: 'rgba(253, 246, 222, 1)',
      title: 'Flexible pricing (Pay as you go)',
      description: 'Only pay for what you need - a plan that grows with you.',
    },
    {
      icon: 'rocket_launch',
      backgroundColor: 'rgba(255, 213, 202, 1)',
      title: 'Activate in just 10 min',
      description:
        "Quick setup means you're ready to go in no time - hassle-free!",
    },
  ];

  fourPillars = [
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image1.png',
      heading: 'People',
      description:
        'Boost staff productivity with efficient tools and secure, role-based access.',
      number: '01',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image2.png',
      heading: 'Finance',
      description:
        'Manage finances, fee collection, and reports effortlessly in one place.',
      number: '02',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image3.png',
      heading: 'Classroom',
      description:
        'Simplify operations and improve learning with smart classroom tools.',
      number: '03',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image4.png',
      heading: 'Communication',
      description:
        'Keep staff and parents connected with real-time, transparent communication.',
      number: '04',
    },
  ];

  baseUrl = 'https://cal.com/inforida-demo/30min';
  updatedLink: string = '';

  logoUrl: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(ElementRef) private elementRef: ElementRef,
    public apiService: APIService,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog,
    private title: Title,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.title.setTitle("Elevate Your School's Performance With Inforida");
    this.meta.addTags([
      {
        name: 'title',
        content: "Elevate Your School's Performance With Inforida",
      },
      {
        name: 'description',
        content: `${formatDate(
          Date.now(),
          'EEE, dd MMMM YYYY',
          'en-US'
        )} : Join the smart schools revolution with Inforida. Our cutting-edge products and services are designed for your success. Request a demo today.`,
      },
      {
        name: 'keywords',
        content:
          'smart school, school erp, education technology, school performance, schools of future, best school erp, school admission software, fees collection software, school fees, school attendance, school tools, school management, Edtech solutions, Classroom technology, Digital learning tools, School management software, Student information systems, Learning management systems, Educational apps, Academic technology, Online learning platforms, E- learning solutions, Education technology, Classroom management solutions, Customizable digital tools, School administration software, Teacher productivity tools, Parent communication platform, Student performance analytics',
      },
    ]);

    this.getLogo();
    // this.setupIntersectionObserver();
    this.updateLink();
    if (isPlatformBrowser(this.platformId)) {
      this.slideInt = setInterval(() => {
        this.nextslide();
      }, this.slideInterval);
      setTimeout(() => {
        this.isImageLoaded = true;
      }, 0);
    }
    this.currentValue = this.getCountEveryDay();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.inputWrapper) {
        this.setupIntersectionObserver();
      }
    });
  }

  onAnimationDone(event: any) {
    if (event.toState === 'out') {
      this.isInView = false;
    }
  }

  // setupIntersectionObserver() {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           this.isInView = true; // Trigger animations
  //         } else {
  //           this.isInView = false; // Reset for next trigger
  //         }
  //       });
  //     },
  //     {
  //       threshold: 0.5, // Trigger when 50% of the element is in view
  //     }
  //   );

  //   observer.observe(this.inputWrapper.nativeElement);
  // }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isInView = true;
          } else {
            this.isInView = false;
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    observer.observe(this.inputWrapper.nativeElement);
  }

  goToPage() {
    const url =
      'https://cal.com/inforida-demo/30min?month=2025-01&date=2025-01-18';
    if (isPlatformBrowser(this.platformId)) {
      window.open(this.updatedLink, '_blank');
    }
  }

  updateLink() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const date = today.getDate().toString().padStart(2, '0');
    this.updatedLink = `${this.baseUrl}?month=${year}-${month}&date=${year}-${month}-${date}`;
  }

  animationCreated(animationItem: AnimationItem): void {
    animationItem.setSpeed(0.6);
    console.log(animationItem);
  }

  getImgSize() {
    if (this.isMobile()) {
      return this.imageSizeMobile;
    } else {
      return this.imageSize;
    }
  }

  getLogo() {
    this.apiService.getSchoolLogo().subscribe((res: any) => {
      this.logoUrl = res;
      console.log(this.logoUrl, 'this is from the result');
    });
    if (this.logoUrl.length) {
      let thumbSize = 'h_280,w_360';
      let finalSize = 'h_800';

      this.logoUrl = this.logoUrl.map((img: any) => {
        img.thumbImage = this.transformImageSize(img.url, thumbSize);
        img.image = this.transformImageSize(img.url, finalSize);
        img.alt = '';
        img.title = '';
        return img;
      });
      console.log(this.logoUrl);
      // console.log('this.school.gallery after ', this.school.gallery);
    }
  }

  transformImageSize(url, size) {
    if (url && url.length && url.includes('cloudinary')) {
      const urlSplit = url.split('/upload/');
      return `${urlSplit[0]}/upload/${size}/${urlSplit[1]}`;
    }
    return url;
  }

  ngOnDestroy() {
    if (this.slideInt) {
      clearInterval(this.slideInt);
    }
  }

  isMobile(): boolean {
    return this.deviceService.isMobile();
  }

  openDialog() {
    this.dialog.open(LeadFormComponent, {
      width: this.isMobile() ? '90vw' : '800px',
      maxWidth: this.isMobile() ? '90vw' : '800px',
      height: this.isMobile() ? '90vh' : '600px',
      maxHeight: this.isMobile() ? '90vh' : '600px',
      restoreFocus: false,
      hasBackdrop: true,
      closeOnNavigation: false,
      disableClose: true,
    });
  }
  selectCard(index: number) {
    this.selectedIndex = index;
  }
  nextslide() {
    if (this.selectedIndex === this.userCards.length - 1) {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex = this.selectedIndex + 1;
    }
  }

  // Redirect to the post job page
  onPostJob(): void {
    // this.router.navigate(['/post-job']);
  }

  // Redirect to the find job page
  onFindJob(): void {
    // this.router.navigate(['/find-job']);
  }

  getCountEveryDay() {
    const baseValue = 6307;
    const increment = 11;
    const date = new Date('2025-03-24');
    const currentDate = new Date();

    const timeDifference = currentDate.getTime() - date.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

    return baseValue + daysDifference * increment;
  }
}
